import React from 'react';
import { EditDaysOfWeekCell } from '../cells/EditDaysOfWeekCell';
import EditEffectiveCell from '../cells/EditEffectiveCell';
import EditFrequencyCell from '../cells/EditFrequencyCell';
import { PrnCell } from '../cells/PrnCell';
import { CPF_EDIT_MODE } from '../../editPolicy';

export const DaysOfWeekCellRenderer = (props: any) => {
  const { editData } = props;
  return (
    <EditDaysOfWeekCell
      data={editData.data}
      rgHash={editData.rgHash}
      node={editData.node}
      editMode={CPF_EDIT_MODE.ORDER}
      isEditable
    />
  );
};

export const EffectiveCellRenderer = (props: any) => {
  const { editData } = props;

  return (
    <EditEffectiveCell
      data={editData.data}
      node={editData.node}
      rgHash={editData.rgHash}
      style={{ height: 100 }}
      editMode={CPF_EDIT_MODE.ORDER}
      isEditable
    />
  );
};

export const FrequencyCellRenderer = (props: any) => {
  const { editData } = props;
  return (
    <EditFrequencyCell
      data={editData.data}
      node={editData.node}
      rgHash={editData.rgHash}
      style={{ height: 100 }}
      editMode={CPF_EDIT_MODE.ORDER}
      isEditable
    />
  );
};

export const PrnCellRenderer = (props: any) => {
  const { editData } = props;

  return (
    <PrnCell
      data={editData.data}
      node={editData.node}
      rgHash={editData.rgHash}
      style={{ height: 100 }}
      viewModePrint={editData.viewModePrint}
      editMode={CPF_EDIT_MODE.ORDER}
      isEditable
    />
  );
};
